import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import ThemeLocalization from 'components/ThemeLocalization';
import {
  QueryClient as QueryClientMain,
  QueryClientProvider,
} from 'react-query';
import Router from 'routes';
import ThemeColorPresets from './components/ThemeColorPresets';
import ThemeProvider from './theme';
// eslint-disable-next-line import/no-extraneous-dependencies
import { QueryClient } from '@tanstack/query-core';
import { SnackbarUtilsConfigurator } from 'utils/SnackbarUtils';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

const queryClient = new QueryClientMain({
  defaultOptions: {
    queries: {
      cacheTime: 0,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <PersistQueryClientProvider
        client={queryClient as unknown as QueryClient}
        persistOptions={{ persister }}
      >
        <SnackbarUtilsConfigurator />
        <ThemeProvider>
          <ThemeColorPresets>
            <ThemeLocalization>
              <Router />
            </ThemeLocalization>
          </ThemeColorPresets>
        </ThemeProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </PersistQueryClientProvider>
    </QueryClientProvider>
  );
}

export default App;
